// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'



//VUEX 
import Vuex from 'vuex'
Vue.use(Vuex)
import { store } from '@/store/store.js';
//.VUEX 

//AXIOS
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = store.state.server;
//.AXIOS



//IDIOMAS
import VueI18n from 'vue-i18n'
import messages from './translations';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: store.state.language, 
  messages,
});
//.IDIOMAS


//VEE-VALIDATE
import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';
Vue.use(VeeValidate);

switch (store.state.language) {
  case "es":
  Validator.localize('es', validatorEs);
  break;
  case "en":
  Validator.localize('en', validatorEn);
  break;
}
//.VEE-VALIDATE

var VueScrollTo = require('vue-scrollto'); 
Vue.use(VueScrollTo,{
	offset: 100,
})




Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	i18n,
	store,
  VeeValidate,
  VueScrollTo,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js